export * from '@fhs/routing/src/routes/(product)/menu/[slug]/customize';
export { default } from '@fhs/routing/src/routes/(product)/menu/[slug]/customize';
